import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'

interface BackButtonProps {
  to?: string;
  label?: string;
  className?: string;
}

export function BackButton({ to, label = "Retour", className = "" }: BackButtonProps) {
  const navigate = useNavigate()
  
  const handleClick = () => {
    if (to) {
      navigate(to)
    } else {
      navigate(-1)
    }
  }
  
  return (
    <Button
      variant="ghost"
      onClick={handleClick}
      className={`flex items-center text-gray-600 hover:text-gray-800 ${className}`}
    >
      <ArrowLeft className="h-4 w-4 mr-2" />
      {label}
    </Button>
  )
}